// One date format across the app: dd/mm/yyyy (and dd/mm/yyyy, HH:mm with a
// time). Never use toLocaleDateString() / toLocaleString() for dates — they
// follow the browser's language and show mm/dd/yyyy on US-English browsers.

const pad = (n) => String(n).padStart(2, '0');

// A date-only value ("2020-12-31") is a calendar date: read it as local so it
// doesn't shift a day in time zones behind UTC.
function toDate(value) {
  if (value === null || value === undefined || value === '') return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  const s = String(value);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  const d = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(s);
  return isNaN(d.getTime()) ? null : d;
}

/** dd/mm/yyyy, or `fallback` when empty / not a date. */
export function formatDate(value, fallback = '—') {
  const d = toDate(value);
  if (!d) return fallback;
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

/** dd/mm/yyyy, HH:mm (24-hour), or `fallback` when empty / not a date. */
export function formatDateTime(value, fallback = '—') {
  const d = toDate(value);
  if (!d) return fallback;
  return `${formatDate(d)}, ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
